import { useEffect } from "react";
import { useLocation } from "react-router";
import { styled } from "styled-components";

import { UIToggle } from "common/components";
import { useSelector } from "common/utilities/react-redux";
import { useGo } from "common/utilities/useGo";
import { useTrack } from "common/utilities/useTrack";
import { useTranslate } from "common/utilities/useTranslate";
import { CreateCollectionsTab } from "domains/create/landing/CreateCollectionsTab";
import { CreateMapsTab } from "domains/create/landing/CreateMapsTab";
import { PublicCreateLanding } from "domains/create/landing/PublicCreateLanding";
import { getCanAccessCreate, getCanEditCollections } from "entities/permissions/selectors";

const StyledContainer = styled.div`
  height: 100%;
  overflow-y: auto;
`;

const StyledToggleContainer = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
  padding-top: 2rem;
  width: 100%;
`;

const StyledToggle = styled(UIToggle)`
  margin: 0 1rem;
  width: 32rem;
`;

export const CreateLanding = () => {
  const go = useGo();
  const { search } = useLocation();
  const canAccessCreate = useSelector(getCanAccessCreate);
  const canEditCollections = useSelector(getCanEditCollections);
  const track = useTrack();
  const translate = useTranslate();

  const mode = new URLSearchParams(search).get("mode") === "collection" ? "collection" : "map";

  useEffect(() => track({ name: "Browse page", page: "Create landing" }), [track]);

  useEffect(() => {
    if (!canEditCollections && mode === "collection") go("/create", { replace: true });
  }, [canEditCollections, go, mode]);

  const items = [
    { text: translate("app.create.landing_toggle.maps"), value: "map" },
    { text: translate("app.create.landing_toggle.collections"), value: "collection" },
  ];

  const onChange = () => go(`/create?mode=${mode === "map" ? "collection" : "map"}`);

  return canAccessCreate ? (
    <StyledContainer>
      {canEditCollections && (
        <StyledToggleContainer>
          <StyledToggle onChange={onChange} value={mode} name="toggleCreateMode" items={items} />
        </StyledToggleContainer>
      )}
      {mode === "map" || !canEditCollections ? <CreateMapsTab /> : <CreateCollectionsTab />}
    </StyledContainer>
  ) : (
    <PublicCreateLanding />
  );
};
